<template>
  <div class="wrapper">
    <side-bar class="no-scrollbar shadow lg-shadow">
      <sidebar-link class="submenuberanda" to="/admin/home" v-if="['master_admin','admin','finance','petugas','tax'].includes(role)">
        <i class="submenuberandai fa fa-home" aria-hidden="true"></i>
        {{dicts.home[dicts.lang]}}
      </sidebar-link>
      
      <!-- DATA MASTER -->
      <sidebar-link tag="li" style="cursor: pointer;user-select:none" @click.native="dmLink=!dmLink" v-if="permissions.datamaster.master.includes(role)">
        <i class="submenuberandai fa fa-database" aria-hidden="true"></i>
        {{dicts.masterdata[dicts.lang]}} <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
        <transition name="fade">
          <div class="w-100 my-2 pl-1 border border-light shadow-sm submenu" v-if="dmLink">
            <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/datamaster/vessel" v-if="permissions.datamaster.submodule.vessel.includes(role)"><i class="fa fa-map-marker" aria-hidden="true"></i> <span>{{dicts.vessel[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.listvessel.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/datamaster/list-kapal"><i class="fa fa-ship" aria-hidden="true"></i> <span>{{dicts.listvessel[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.user.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/pengguna"><i class="fa fa-universal-access" aria-hidden="true"></i> <span>{{dicts.user[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.client.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/klien"><i class="fa fa-user" aria-hidden="true"></i> <span>{{dicts.client[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.rekeningbank.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/rekening-bank"><i class="nc-icon nc-notes submenui" ></i> <span>{{dicts.banks[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.datavendor.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/vendor"><i class="nc-icon nc-credit-card submenui" ></i> <span>{{dicts.vendor[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.tipeperangkat.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/hardwaretype"><i class="submenui"><img src="/img/icon-inventaris.svg"/></i> <span>{{dicts.itemtype[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.perangkat.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/hardware"><i class="submenui"><img src="/img/icon-inventaris.svg"/></i> <span>{{dicts.item[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.hargaperangkat.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/hardware-price"><i class="nc-icon nc-money-coins submenui"></i> <span>{{dicts.itemprice[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.hargaairtime.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/airtime-price"><i class="nc-icon nc-money-coins submenui"></i> <span>{{dicts.airtimeprice[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.hargaitem.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/item-lain"><i class="nc-icon nc-money-coins submenui"></i> <span>{{dicts.hargaitem[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.discount.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/discount"><i class="nc-icon nc-tag-content submenui"></i> <span>{{dicts.discount[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.aplikasi.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/application"><i class="nc-icon nc-paper-2 submenui" ></i> <span>{{dicts.application[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.paket.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/packet"><i class="nc-icon nc-single-copy-04 submenui"></i> <span>{{dicts.packet[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.tipekwitansi.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/kwitansi-type"><i class="nc-icon nc-single-copy-04 submenui"></i> <span>{{dicts.kwitansitype[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.location.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/location"><i class="nc-icon nc-map-big submenui"></i> <span>{{dicts.location[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.warehouse.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/warehouse"><i class="nc-icon nc-map-big submenui"></i> <span>{{dicts.warehouse[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.complaint.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/complaint"><i class="nc-icon nc-settings-90 submenui"></i> <span>{{dicts.complaint[dicts.lang]}}</span></sidebar-link>
          </div>
        </transition>
      </sidebar-link >

      <!-- INVENTARIS -->
      <sidebar-link tag="li" style="cursor: pointer;user-select:none" @click.native="dmLinkInventaris=!dmLinkInventaris"  v-if="permissions.inventaris.master.includes(role)">
        <i class="submenuberandai fa fa-window-maximize" aria-hidden="true"></i>
        {{dicts.inventory[dicts.lang]}} <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
        <transition name="fade">
          <div class="w-100 my-1 pl-1 border border-light shadow-sm submenu" v-if="dmLinkInventaris">
            <sidebar-link v-if="permissions.inventaris.submodule.qc.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/inventaris/hardware-qc"><i class="submenui"><img src="/img/icon-inventaris.svg"/></i> <span>{{dicts.qc[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.inventaris.submodule.setup.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/inventaris/hardware-setup"><i class="submenui"><img src="/img/icon-inventaris.svg"/></i> <span>{{dicts.setup[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.inventaris.submodule.warehouse.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/inventaris/warehouse"><i class="submenui"><img src="/img/icon-inventaris.svg"/></i> <span>{{dicts.warehouse_stock[dicts.lang]}}</span></sidebar-link>
          </div>
        </transition>
      </sidebar-link>

      <!-- Order -->
      <sidebar-link tag="li" style="cursor: pointer; user-select: none" @click.native="dmLinkPemesanan=!dmLinkPemesanan"  
      v-if="permissions.pemesanan.master.includes(role)">
      <i class="submenuberandai fa fa-cart-arrow-down" aria-hidden="true"></i>
      {{ dicts.order[dicts.lang] }} 
      <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
      <transition name="fade">
          <div class="w-100 my-2 pl-1 border border-light shadow-sm submenu" v-if="dmLinkPemesanan">

              <!-- Purchase Order -->
              <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" 
                            to="/admin/pemesanan/purchase-order" 
                            v-if="permissions.pemesanan.submodule.po.includes(role)">
                  <i class="submenui fa fa-file-powerpoint-o" aria-hidden="true"></i> 
                  <span>{{ dicts.po[dicts.lang] }}</span>
              </sidebar-link>

              <!-- Sales order -->
              <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" 
                            to="/admin/pemesanan/sales-order" 
                            v-if="permissions.pemesanan.submodule.so.includes(role)">
                  <i class="submenui fa fa-file-text" aria-hidden="true"></i> 
                  <span>{{ dicts.so[dicts.lang] }}</span>
              </sidebar-link>

              <!-- Invoice Barang -->
              <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" 
                            to="/admin/pemesanan/invoice-item" 
                            v-if="permissions.pemesanan.submodule.invoiceitem.includes(role)">
                  <i class="submenui fa fa-file-text-o" aria-hidden="true"></i> 
                  <span>{{ dicts.invoiceitem[dicts.lang] }}</span>
              </sidebar-link>

              <!-- Invoice Jasa -->
              <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" 
                            to="/admin/pemesanan/invoice-airtime" 
                            v-if="permissions.pemesanan.submodule.invoiceairtime.includes(role)">
                  <i class="submenui fa fa-file-text-o" aria-hidden="true"></i> 
                  <span>{{ dicts.invoiceairtime[dicts.lang] }}</span>
              </sidebar-link>

              <!-- Invoice Other-->
              <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" 
                            to="/admin/pemesanan/invoice-lain" 
                            v-if="permissions.pemesanan.submodule.otherinvoice.includes(role)">
                  <i class="submenui fa fa-file-text-o" aria-hidden="true"></i> 
                  <span>{{ dicts.otherinvoice[dicts.lang] }}</span>
              </sidebar-link>
          </div>
      </transition>
  </sidebar-link>
    
      <sidebar-link tag="li" style="cursor: 
        pointer;user-select:none" 
        @click.native="dmLinkPengingat=!dmLinkPengingat" v-if="permissions.pengingat.master.includes(role)">
        <i class="submenui fa fa-bell-o" aria-hidden="true"></i>
        {{dicts.reminder[dicts.lang]}} <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
        <transition name="fade">
          <div class="w-100 my-2 pl-1 border border-light shadow-sm submenu" v-if="dmLinkPengingat">
            <!-- <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/pengingat/renewal-airtime"><i class="nc-icon nc-bell-55 submenui"></i> <span>Airtime baru</span></sidebar-link> -->
            <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/pengingat/renewal-airtime" v-if="permissions.pengingat.submodule.renewalairtime.includes(role)">
            <i class="submenui"><img src="/img/icon-pengingat.svg"/></i>
              <span>{{dicts.renewalairtime[dicts.lang]}}</span>
            </sidebar-link>
            </div>
        </transition>
      </sidebar-link>
      <sidebar-link tag="li" style="cursor: pointer;user-select:none" @click.native="dmLinkMonitoring=!dmLinkMonitoring" v-if="permissions.troubleshoot.master.includes(role)">
        <i class="submenui fa fa-cog" aria-hidden="true"></i>
        {{dicts.troubleshoot[dicts.lang]}} <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
        <transition name="fade">
          <div class="w-100 my-2 pl-1 border border-light shadow-sm submenu" v-if="dmLinkMonitoring">
                <sidebar-link class="submenuberanda" to="/misc/troubleshoot" v-if="permissions.troubleshoot.submodule.monitoring.includes(role)">
              <i class="submenui"><img src="/img/icon-perbaikan.svg"/></i>
              {{dicts.monitoring[dicts.lang]}}
            </sidebar-link>
          </div>
        </transition>
      </sidebar-link>
      <template slot="bottom-links">
        <mobile-menu slot="content"></mobile-menu>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>
    </div>
  </div>
</template>

<style lang="scss">
  

</style>

<style scoped>
::v-deep .sidebar .sidebar-wrapper, body > .navbar-collapse .sidebar-wrapper {
    background: #170BCA;
}
.sidebar .nav li .nav-link .icons i {
    font-size: 15px;
    margin-right: 15px;
    padding-top: 5px;
}
::v-deep .sidebar .logo, body > .navbar-collapse .logo {
    background: #F2F6FC;
    box-shadow: 0px 1px 3px #dfdfdf;
    border: 0.1px solid #dfdfdf;
}

 ::v-deep .sidebar .nav li .nav-link, body > .navbar-collapse .nav li {
    /* color: #fff !important; */
}

::v-deep .sidebar .nav li.active .nav-link, body > .navbar-collapse .nav li.active {
    background: #E5E9EC;
}
::v-deep .sidebar .nav li:hover .nav-link, body > .navbar-collapse .nav li:hover  {
    background: #fff;
    /* color: #fff !important; */
    
    opacity: 1;
    font-weight: bold;
}

::v-deep .sidebar .nav li:visited .nav-link, body > .navbar-collapse .nav li:visited  {
    background: rgb(226, 227, 233);
    opacity: 1;
    color: #002060;
}
::v-deep .border {
  border: 0px solid #dee2e6 !important;
}
.submenu {
  background: rgba(255, 255, 255, 1);
  color: #000000  !important;
  opacity: 1;
  border-radius: 5px;
}
.submenu .submenui, span {
  color: #000000;
}
.submenuberanda .submenuberandai.active {
  color: #000000;
}

.sidebar .nav li .nav-link, body > .navbar-collapse .nav li .nav-link {
    /* color: #fff !important; */
    opacity: 1;
    border:0;
}

::v-deep .sidebar .nav li .nav-link i, body > .navbar-collapse .nav li .nav-link i {
    font-size: 22px;
    margin-right: 5px;
}
::v-deep .sidebar .nav .nav-link, body > .navbar-collapse .nav .nav-link {
    margin: 0;
    font-size: 11px;
}

</style>
<style>
body{
  font-size: 14px;
}
.navbar {
    font-size: 14px;
    padding: 0 15px;
}
.submenuberandai {
    color: #150461; /* Warna default */
}
.submenui {
    color: #150461; /* Warna default */
}

</style>
<script>
  import {EventBus} from './../eventbus'
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    data(){
      return {
        passVisible:false,
        role:'',
        dmLink:false,
        dmLinkInventaris:false,
        dmLinkPemesanan:false,
        dmLinkPengingat:false,
        dmLinkLaporan:false,
        dmLinkMonitoring:false,
        dmLinkTroubleshoot:false,
        permissions:{
            datamaster:{
              master:['admin','client','master_admin','petugas','finance','tax'],
              submodule:{
                vessel:['master_admin','admin'],
                listvessel:['master_admin','admin','petugas','finance','tax'],
                user:['master_admin'],
                client:['master_admin','admin','tax'],
                rekeningbank:['master_admin','admin','finance'],
                datavendor:['master_admin','admin',],
                tipeperangkat:['master_admin','admin',],
                perangkat:['master_admin','admin',],
                hargaperangkat:['master_admin','admin','finance','tax'],
                hargaairtime:['master_admin','admin','finance','tax'],
                hargaitem:['master_admin','admin','finance','tax'],
                discount:['master_admin','admin','finance'],
                aplikasi:['master_admin','admin',],
                paket:['master_admin','admin',],
                tipekwitansi:['admin','master_admin'],
                location:['master_admin','admin'],
                warehouse:['master_admin','admin',],
                complaint:['master_admin','admin',],
              }
            },
            inventaris:{
              master:['master_admin','admin','finance','petugas'],
              submodule:{
                qc:['master_admin','admin'],
                setup:['master_admin','admin','petugas'],
                warehouse:['master_admin','admin','finance'],
              }
            },
            pemesanan:{
              master:['master_admin','admin','finance','tax'],
              submodule:{
                po:['master_admin','admin'],
                kwitansi:['master_admin','admin','finance','tax'],
                so:['master_admin','admin','finance','tax'],
                invoiceitem:['master_admin','admin','finance','tax'],
                invoiceairtime:['master_admin','admin','finance','tax'],
                otherinvoice:['master_admin','admin','finance','tax'],
              }
            },
            pengingat:{
              master:['master_admin','admin','finance','petugas'],
              submodule:{
                renewalairtime:['master_admin','admin','finance','petugas']
              }
            },
            laporan:{
              master:['master_admin','admin','finance','tax'],
              submodule:{
                unit:['master_admin','admin','finance','tax'],
                airtime:['master_admin','admin','finance','tax'],
                so:['master_admin','admin','finance','tax'],
                other:['master_admin','admin','finance','tax'],
                receipt:['master_admin','admin','finance','tax'],
                reminderletter:['master_admin','admin','finance','tax'],
                troubleshootreport:['master_admin','admin',]
              }
            },
            troubleshoot:{
              master:['master_admin','petugas'],
              submodule:{
                monitoring:['master_admin','petugas']
              }
            },
           
        },
        dicts:{
            lang:'id',
            home:{
                id:"Beranda",
                en:"Home"
            },
            masterdata:{
                id:"Data master",
                en:"Master data"
            },
            vessel:{
                id:"Kapal",
                en:"Vessel"
            },
            listvessel:{
                id:"List kapal",
                en:"List vessel"
            },
            user:{
                id:"Staff",
                en:"Staff"
            },
            client:{
                id:"Pelanggan",
                en:"Customer"
            },
            banks:{
                id:"Rekening bank",
                en:"Bank accounts"
            },
            vendor:{
                id:"Vendor",
                en:"Vendor"
            },
            itemtype:{
                id:"Tipe perangkat",
                en:"ITEM CATEGORY"
            },
            item:{
                id:"Perangkat",
                en:"Item"
            },
            itemprice:{
                id:"Harga perangkat",
                en:"Item price"
            },
            airtimeprice:{
                id:"Harga airtime",
                en:"Airtime price"
            },
            hargaitem:{
                id:"Item lainnya",
                en:"Secondary item"
            },
            discount:{
                id:"Diskon",
                en:"Discount"
            },
            application:{
                id:"Aplikasi",
                en:"Application"
            },
            packet:{
                id:"Paket",
                en:"Packet"
            },
            kwitansitype:{
                id:"Tipe Kwitansi",
                en:"Kwitansi Type"
            },
            inventory:{
                id:"Inventaris",
                en:"Inventory"
            },
            inventory:{
                id:"Inventaris",
                en:"Inventory"
            },
            qc:{
                id:"Hardware QC",
                en:"Hardware QC"
            },
            setup:{
                id:"Hardware setup",
                en:"Hardware setup"
            },
            warehouse_stock:{
                id:"Warehouse Stock",
                en:"Warehouse Stock"
            },
            invoiceitem:{
                id:"INVOICE BARANG",
                en:"GOODS INVOICE"
            },
            invoiceairtime:{
                id:"INVOICE JASA",
                en:"SERVICE INVOICE"
            },
            otherinvoice:{
                id:"INVOICE OTHER",
                en:"OTHER INVOICES"
            },
            order:{
                id:"PENJUALAN",
                en:"SALE"
            },
            po:{
                id:"Purchase Order",
                en:"Purchase Order"
            },
            kwitansi:{
                id:"Kwitansi",
                en:"Kwitansi"
            },
            so:{
                id:"Sales Order",
                en:"Sales Order"
            },
            reminder:{
                id:"Pengingat",
                en:"Reminder"
            },
            renewalairtime:{
                id:"Report Status",
                en:"Report Status"
            },
            monitoring:{
                id:"Pemantauan",
                en:"Monitoring"
            },
            troubleshoot:{
                id:"Perbaikan",
                en:"Troubleshoot"
            },
            location:{
                id:"Lokasi",
                en:"Location"
            },
            warehouse:{
                id:"Gudang",
                en:"Warehouse"
            },
            complaint:{
                id:"Keluhan",
                en:"Complaint"
            },
            reminderletter:{
                id:"Surat pemberitahuan",
                en:"Reminder letter"
            },
            troubleshootreport:{
                id:"Troubleshoot",
                en:"Perbaikan"
            },
            anotherinvoice:{
                id:"Invoice lain-lain",
                en:"Another invoice"
            },
            report:{
                id:"Laporan",
                en:"Report"
            },
            other:{
                id:"Penjualan",
                en:"Other"
            },
            receipt:{
                id:"Kwitansi",
                en:"Receipt"
            },
            unit:{
                id:"Satuan",
                en:"Unit"
            },
            // reportpsdkp:{
            //     id:"monitapidatavms",
            //     en:"monitadatavms"
            // },
            // monitoringpsdkp:{
            //     id:"monitapidatapsdkp",
            //     en:"monitadatapsdkp"
            // },
        }
      }
    },
    created(){
      //step 1 auto logout, taruh ini disetiap action
      this.role=localStorage.getItem('role');
      console.log('kok ga ada',this.role);
      EventBus.$on('lang',()=>{
        this.dicts.lang = localStorage.getItem('lang');
      })
    },
    methods: {
      
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
    },
    
  }

</script>
